var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.sortable)?_c('span',{class:_vm.props.class},[_c('b-icon',{attrs:{"icon":_vm.props.sortStatus.sorted === false
        ? 'arrow-down-up'
        : _vm.props.sortStatus.asc
        ? 'arrow-up'
        : 'arrow-down'}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }